// extracted by mini-css-extract-plugin
export default {"styled-nav":"Navbar_styled-nav__xzdIU"};